export default "__VITE_ASSET__DZHm4CfQ__"